import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  color: #999;
`;

const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PhoneInput = styled.input`
  flex: 1;
  height: 50px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 15px;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #2282e9;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  width: 100%;
`;

const SubmitButton = styled.button`
    
  width: 120px;
  height: 50px;
  border-radius: 5px;
  background-color: #2282e9;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 14px;
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
`;

const ResultContainer = styled.div`
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  margin-bottom: 10px;
`;

const ProviderText = styled.p`
  font-size: 16px;
  color: #333;
  margin: 0;
  
  span {
    color: #2282e9;
    font-weight: 600;
  }
`;

interface PhoneVerificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    phoneNumber: string;
    setPhoneNumber: (e: React.ChangeEvent<HTMLInputElement>) => void;
    errorMessage: string;
    showVerificationInput: boolean;
    verificationCode: string;
    setVerificationCode: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleRequestVerification: () => void;
    handleVerifyCode: () => void;
    isVerified: boolean;
    validationResult: { provider: string } | null;
    showModalResult: boolean;
    handleConfirmButton?: () => void;
}

export default function PhoneVerificationModal({
    isOpen,
    onClose,
    phoneNumber,
    setPhoneNumber,
    errorMessage,
    showVerificationInput,
    verificationCode,
    setVerificationCode,
    handleRequestVerification,
    handleVerifyCode,
    isVerified,
    validationResult,
    showModalResult,
    handleConfirmButton
}: PhoneVerificationModalProps) {
    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContainer>
                <ModalHeader>
                    <ModalTitle>전화번호로 가입된 플랫폼 찾기</ModalTitle>
                    <CloseIcon onClick={onClose}>✕</CloseIcon>
                </ModalHeader>
                <ModalBody>
                    <span style={{ fontSize: '14px', color: '#2282E9', marginBottom: '10px' }}>
                        휴대폰 번호를 입력해주세요
                    </span>
                    <InputWrapper>
                        <PhoneInput
                            type="tel"
                            placeholder="- 없이 입력"
                            value={phoneNumber}
                            onChange={setPhoneNumber}
                            maxLength={11}
                        />
                        <SubmitButton
                            onClick={handleRequestVerification}
                            disabled={phoneNumber.length !== 11}
                        >
                            인증번호 받기
                        </SubmitButton>
                    </InputWrapper>

                    {showVerificationInput && (
                        <InputWrapper>
                            <PhoneInput
                                type="tel"
                                placeholder="인증번호를 입력해주세요"
                                value={verificationCode}
                                onChange={setVerificationCode}
                                maxLength={6}
                            />
                            <SubmitButton
                                onClick={handleVerifyCode}
                                disabled={verificationCode.length !== 4}
                            >
                                인증하기
                            </SubmitButton>
                        </InputWrapper>
                    )}

                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

                    {showModalResult && validationResult && (
                        <>
                            <ResultContainer>
                                <ProviderText>
                                    이 전화번호는 <span>{validationResult.provider}</span>로 가입된 계정입니다.
                                </ProviderText>

                            </ResultContainer>
                            <SubmitButton onClick={onClose}>
                                로그인 하러 가기
                            </SubmitButton>
                        </>
                    )}

                </ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );
} 